import { FC, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { TutorialDialog } from '@/_shared/components';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';

export const TutorialLearning: FC = () => {
  const t = useTranslations('trainingHardSkills.tutorial.learning.slides');
  const { openDialog: openDialogTutorial } = useDialog('trainingHardSkillsLearningTutorial');
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialHardSkillsLearningSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialHardSkillsLearningSlide2',
    },
  ];

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.TrainingHardSkillsLearning)) {
      openDialogTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogTutorial]);

  return (
    <TutorialDialog
      translationsKey='trainingHardSkills.tutorial.learning'
      dialogKey='trainingHardSkillsLearningTutorial'
      slides={slides}
    />
  );
};
